module.exports = __webpack_public_path__ + "static/liva-sm-8148b2f0ca4f25f9fd9bb5a793cd7ce7.jpg";